import {
  BillingIcon,
  CalendarIcon,
  ConsentFormIcon,
  FolderIcon,
  HomeIcon,
  MailOpenIcon,
  ReportIcon,
} from 'core/icons';
import appointmentRoutes from 'pages/Dashboard/pages/Appointments/routes';
import billingRoutes from 'pages/Dashboard/pages/Billing/routes';
import chartsRoutes from 'pages/Dashboard/pages/Charts/routes';
import dashboardRoutes from 'pages/Dashboard/pages/Dashboard/routes';
import encountersRoutes from 'pages/Dashboard/pages/Encounters/routes';
import isNil from 'lodash/isNil';
import ToDosSidebarItem from 'pages/Dashboard/components/ToDosSidebarItem';
import faxRoutes from 'pages/Dashboard/pages/Fax/routes';
import formsRoutes from 'pages/Dashboard/pages/Forms/routes';
import {
  Route,
} from 'types/commonTypes';
import {
  LoggedInUserInfoAccess,
} from 'views/EMR/access';
import PCCIcon from 'core/icons/pcc';

export default [{
  Icon: HomeIcon,
  name: 'Encounters',
  href: 'encounters',
  subRoutes: encountersRoutes,
}, {
  Icon: FolderIcon,
  name: 'Charts',
  href: 'charts',
  className: '!hidden',
  subRoutes: chartsRoutes,
}, {
  Icon: CalendarIcon,
  name: 'Appointments',
  href: 'appointments',
  subRoutes: appointmentRoutes,
}, {
  name: 'Todos',
  href: 'todos',
  title: 'To-dos',
  Component: ToDosSidebarItem,
}, {
  Icon: BillingIcon,
  name: 'Billing',
  href: 'billing',
  subRoutes: billingRoutes,
}, {
  Icon: MailOpenIcon,
  name: 'Fax',
  title: 'Fax',
  href: 'fax',
  isVisible: (userInfo: LoggedInUserInfoAccess) => !isNil(userInfo?.organization?.eFaxConfig),
  subRoutes: faxRoutes,
}, {
  Icon: ConsentFormIcon,
  title: 'Forms',
  name: 'Forms',
  href: 'forms',
  subRoutes: formsRoutes,
}, {
  Icon: ReportIcon,
  title: 'Reports',
  name: 'Reports',
  href: 'reports',
}, {
  Icon: PCCIcon,
  title: 'PCC',
  name: 'Dashboard',
  href: 'pcc',
  className: 'border-t border-gray-700',
  subRoutes: dashboardRoutes,
}] as Route[];
